/* eslint-disable no-undef */
import Appsignal from '@appsignal/javascript';

// Substituted at build time by esbuild (see the `define` in esbuild.mjs). typeof-guarded so that
// a bundle built without that define degrades to development instead of throwing a ReferenceError
// at module load, which would take down every pack that imports this.
const buildEnvironment = typeof __SUPERCAST_JS_ENV__ === 'string' ? __SUPERCAST_JS_ENV__ : 'development';

// The build-time value CANNOT distinguish our deployed environments, so it can't be the last
// word. The Dockerfile hardcodes RAILS_ENV=production for the asset build, and the staging and
// preview workflows deploy that same image - so every staging and preview front-end error was
// reporting into the PRODUCTION AppSignal app, and the 'staging' branch below was dead code.
// Rails can't answer it either: those workflows also run with RAILS_ENV=production.
//
// The host is the only thing that actually differs at runtime. Matched on the infix, never on a
// bare `.supercast.tech` suffix: that domain is ALSO production's subscriber-facing domain
// (a channel lives at <subdomain>.supercast.tech), so a suffix test would misfile real
// production errors into staging - worse than the bug being fixed. A single-label channel
// subdomain can't produce `.staging.` or `.pr-<n>.` in the middle, so these two cannot collide
// with production. Anything unrecognised falls back to the build value.
//
// Not utils/environment.js#currentEnvironment: it has no callers and cannot answer this anyway -
// it keys off the last two labels of the hostname, which is "supercast.tech" for staging,
// preview AND every production subscriber page alike.
const STAGING_HOST = /\.staging\.supercast\.tech$/;
const PREVIEW_HOST = /\.pr-\d+\.supercast\.tech$/;

function deployEnvironment() {
  if (typeof window === 'undefined' || !window.location) return buildEnvironment;

  const host = window.location.hostname || '';
  if (STAGING_HOST.test(host)) return 'staging';
  if (PREVIEW_HOST.test(host)) return 'preview';

  return buildEnvironment;
}

const environment = deployEnvironment();

let appsignalKey;

switch (environment) {
  case 'development':
  case 'test':
    appsignalKey = '1351c37f-234b-4022-aec3-0565a0ed6fdb';
    break;
  // Preview deploys are ephemeral per-PR stacks and share the staging app rather than having one
  // of their own - what matters is only that their noise does not look like production.
  case 'staging':
  case 'preview':
    appsignalKey = '0d3a8090-4974-4e92-b75f-03cebdba89ea';
    break;
  case 'production':
    appsignalKey = '8a3ef517-ca57-47fc-bad1-96b4b5aaafe0';
    break;
}

export default new Appsignal({
  key: appsignalKey
})